export const CUSTOM_VIEW_DOCUMENTS_CONFIG = {
    name            : 'Documents',
    menuName        : 'Documents',
    icon            : 'i5-document',
    image           : 'documents',
    iconSvg         : 'isvg-view-documents',
    url             : 'documents',
    stringId        : 'documents',
    description     : 'Documents list view that shows all related documents grouped by date, user or project.'
}
